interface ToggleProps {
  id: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: string;
}

export default function Toggle({ id, checked, onChange, label }: ToggleProps): React.JSX.Element {
  return (
    <div className="toggle-group">
      <button
        id={id}
        type="button"
        role="switch"
        aria-checked={checked}
        aria-label={label}
        className={`toggle ${checked ? 'toggle--active' : ''}`}
        onClick={() => onChange(!checked)}
      >
        <span className="toggle__thumb" />
      </button>
      <label htmlFor={id} className="toggle__label">
        {label}
      </label>
    </div>
  );
}
